<template>
  <div v-if="hasPriceChangeSchedule">
    <BaseAlert
      color="info"
      :text="$t('services.price_update.scheduled_price_update_service')"
      :primaryAction="{
        text: $t('global.actions.view'),
        routerLink: {
          name: 'admin-service-scheduled-price-update'
        },
      }"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useServicesPriceScheduleStore } from '@/stores/services-price-schedule';

const props = defineProps<{
  id?: string | number;
}>();
const { scheduledPriceUpdate } = storeToRefs(useServicesPriceScheduleStore());

const hasPriceChangeSchedule = computed(() => {
  if (!props.id) {
    return false;
  }

  return !!scheduledPriceUpdate.value?.servicePriceChanges?.find(
    (change) => change.service.id.toString() === props.id.toString(),
  );
});
</script>
